import styled, { css } from 'styled-components';

export const BufferBox = styled.div`
  ${({ theme }) => css`
    width: 100%;
    margin-bottom: ${theme.spacings[10]};
    padding: ${theme.spacings[12]};
    border-radius: 12px;
    background: ${theme.colors.white || '#fff'};
    border: 1px solid ${theme.colors.gray200 || '#e4e9f2'};
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.04);
    display: flex;
    flex-direction: column;
    gap: ${theme.spacings[12]};
  `}
`;

export const BufferHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
  font-size: 14px;
`;

export const BufferGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;

  label {
    font-size: 12px;
    font-weight: 600;
    opacity: 0.8;
  }

  input {
    padding: 8px 10px;
    border-radius: 8px;
    border: 1px solid #d5dbe7;
    font-size: 13px;
    background: #f9fbff;
    transition: all 0.2s ease;

    &:focus {
      outline: none;
      border-color: ${({ theme }) => theme.colors.blue700};
      box-shadow: 0 0 0 2px rgba(76, 139, 245, 0.15);
    }
  }
`;
